/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import { useTheme, SvgChevronRight } from '../utils/index.js';
/**
 * Header breadcrumbs, adds chevron between each provided items.
 * @example
 * <HeaderBreadcrumbs
 *   items={[
 *     <HeaderButton key={...} ... />
 *     <HeaderButton key={...} ... />
 *   ]}
 * />
 */
export const HeaderBreadcrumbs = (props) => {
    const { items, ...rest } = props;
    useTheme();
    return (React.createElement("nav", { "aria-label": 'breadcrumbs', className: 'iui-header-breadcrumbs', ...rest },
        React.createElement("ol", { className: 'iui-header-breadcrumbs-list' }, items.reduce((previous, current, index) => [
            ...previous,
            current,
            index !== items.length - 1 && (React.createElement("li", { className: 'iui-breadcrumbs-separator', key: index },
                React.createElement(SvgChevronRight, { key: `chevron${index}`, "aria-hidden": true, className: 'iui-chevron' }))),
        ], []))));
};
export default HeaderBreadcrumbs;
